import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlDespesasMensaisPorFornecedor = '/service/contabilidade/loteServico/'

class DespesasMensaisPorFornecedorService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultar(data) {
        let json = {
            identificador: data.identificador,
            competencia: data.competencia,
        }

        return this.conex.post(urlDespesasMensaisPorFornecedor + 'despesasMensaisPorFornecedor/', JSON.stringify(json))
    }
}

export default DespesasMensaisPorFornecedorService
